import { createSliceWithImmer } from 'zustand-slices/immer';

type ChatBotSlice = {
  openChat: boolean;
  autoOpen: boolean;
};

type ChatBotSliceActions = {
  setOpenChat: (openChat: boolean) => (state: ChatBotSlice) => void;
  setAutoOpen: (autoOpen: boolean) => (state: ChatBotSlice) => void;
};

export const chatBotSlice = createSliceWithImmer<
  'chatBotStore',
  ChatBotSlice,
  ChatBotSliceActions
>({
  name: 'chatBotStore',
  value: {
    openChat: false,
    autoOpen: false,
  },
  actions: {
    setOpenChat: (openChat) => (state) => {
      state.openChat = openChat;
    },
    setAutoOpen: (autoOpen) => (state) => {
      state.autoOpen = autoOpen;
    },
  },
});
